import React from 'react';
import { Button } from 'react-bootstrap';
import './Common.scss';

interface AdminMenuButtonProps {
  onToggle: (isOpen: boolean) => void;
  isOpen: boolean;
}

const AdminMenuButton: React.FC<AdminMenuButtonProps> = ({
  onToggle,
  isOpen,
}) => {
  const handleToggle = (): void => {
    onToggle(!isOpen);
  };

  return (
    <Button
      variant="outline-primary"
      className={`admin-menu-toggle ${isOpen ? 'active' : ''}`}
      onClick={handleToggle}
      style={{
        position: 'fixed',
        top: '20px',
        left: '20px',
        zIndex: 1050,
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid #007bff',
        backgroundColor: isOpen ? '#007bff' : 'white',
        color: isOpen ? 'white' : '#007bff',
        transition: 'all 0.3s ease',
      }}
      title={isOpen ? 'サイドメニューを閉じる' : 'サイドメニューを開く'}
    >
      <div className="hamburger-icon">
        <span className={`hamburger-line ${isOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'active' : ''}`}></span>
        <span className={`hamburger-line ${isOpen ? 'active' : ''}`}></span>
      </div>
    </Button>
  );
};

export default AdminMenuButton;
